import PropTypes from "prop-types";
import React, { useEffect, useMemo, useState } from "react";
import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Badge,
    Button
} from "reactstrap";

//Import Breadcrumb

//i18n
import { withTranslation } from "react-i18next";
import Breadcrumbs from "components/Common/Breadcrumb";
import Select from "react-select";
import { useNavigate,Link } from "react-router-dom";


const Reports = props => {
    const navigate=useNavigate();

    
    //meta title
 
  
    document.title = "Reports List | EventoX";
    const reportsList = [
        // {
        //     title: "Attendee & Door List Report",
        //     description: "Generate comprehensive attendee lists with contact details, ticket information, seating arrangements, and check-in status. Perfect for event day management and guest verification.",
        //     iconClass: "bx-group",
        //     link: "/attendee-report",
        //     color: "primary",
        //     gradient: "bg-gradient-primary",
        //     features: ["Contact Details", "Seating Info", "Check-in Status", "Export Options"]
        // },
        // {
        //     title: "Event Performance Summary",
        //     description: "Get detailed insights into event performance including ticket sales, capacity utilization, session attendance, and overall event success metrics across all your events.",
        //     iconClass: "bx-bar-chart-alt-2",
        //     link: "/event-summery-report",
        //     color: "success",
        //     gradient: "bg-gradient-success",
        //     features: ["Sales Analytics", "Capacity Metrics", "Success Indicators", "Performance Trends"]
        // },
        // {
        //     title: "Revenue Analytics Dashboard",
        //     description: "Comprehensive revenue analysis showing total earnings, revenue breakdown by event, ticket type performance, and financial trends with detailed profit/loss insights.",
        //     iconClass: "bx-dollar-circle",
        //     link: "/eventox-revenue-report",
        //     color: "warning",
        //     gradient: "bg-gradient-warning",
        //     features: ["Revenue Breakdown", "Profit Analysis", "Financial Trends", "Export Reports"]
        // },
        // {
        //     title: "Ticket Sales & Revenue Report",
        //     description: "Detailed breakdown of ticket sales performance, revenue by ticket categories, booking statistics, and sales trends with exportable data for financial reporting.",
        //     iconClass: "bx-ticket",
        //     link: "/ReportV3/booking-status-report",
        //     color: "info",
        //     gradient: "bg-gradient-info",
        //     features: ["Sales Performance", "Category Analysis", "Booking Stats", "Data Export"]
        // },

        {
            title: "Advanced Booking Search & Analytics",
            description: "Powerful search tool to find specific bookings by date range, event, ticket type, venue, organizer, or contact details. Includes comprehensive filtering and export capabilities.",
            iconClass: "bx-search-alt",
            link: "/run-report",
            color: "secondary",
            gradient: "bg-gradient-secondary",
            features: ["Advanced Search", "Multiple Filters", "Export Options", "Real-time Data"]
        },
        {
            title: "All Events Revenue Report",
            description: "Comprehensive revenue analysis showing total earnings, revenue breakdown by event, ticket type performance, and financial trends with detailed profit/loss insights.",
            iconClass: "bx-dollar-circle",
            link: "/all-events-revenue-report",
            color: "warning",
            gradient: "bg-gradient-warning",
            features: ["Revenue Breakdown", "Profit Analysis", "Financial Trends", "Export Reports"]
        }
        // {
        //     title: "Revenue Report by Date Range",
        //     description: "Track revenue performance within specific time periods. Analyze daily, weekly, or monthly revenue trends with detailed breakdowns of Eventox revenue, organizer revenue, and processing fees.",
        //     iconClass: "bx-calendar-check",
        //     link: "/Reportv3/revenue-date-report",
        //     color: "danger",
        //     gradient: "bg-gradient-danger",
        //     features: ["Time-based Analysis", "Revenue Trends", "Fee Breakdown", "Periodic Reports"]
        // }
    ]

    const view=()=>{
        view()
    }
  
    const onNavigateReport=(url)=>{
        navigate(url);
    }
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Header Section */}
                    <div className="mb-4">
                        <Breadcrumbs
                            title={props.t("Reports & Analytics")}
                            breadcrumbItem={props.t("Reports Dashboard")}
                        />
                        
                        {/* Hero Section */}
                        <div className="text-center mb-5">
                            <div className="bg-gradient-primary rounded-3 p-4 mb-4">
                                <h1 className="text-white mb-3 fw-bold">
                                    <i className="bx bx-bar-chart-alt-2 me-3"></i>
                                    Reports & Analytics Center
                                </h1>
                                <p className="text-white-50 mb-0 fs-5">
                                    Comprehensive insights and analytics to drive your event business forward
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Reports Grid */}
                    <Row className="g-4">
                        {reportsList.map((report, key) => (
                            <Col xl={4} lg={6} md={6} key={key}>
                                <Card 
                                    className="report-card h-100 border-0 shadow-sm hover-lift transition-all"
                                    onClick={() => onNavigateReport(report.link)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <CardBody className="p-4">
                                        {/* Header with Icon */}
                                        <div className="d-flex align-items-center mb-4">
                                            <div className={`${report.gradient} rounded-circle p-3 me-3`}>
                                                <i className={`bx ${report.iconClass} text-white fs-3`}></i>
                                            </div>
                                            <div className="flex-grow-1">
                                                <h5 className="card-title mb-1 fw-bold text-dark">
                                                    {report.title}
                                                </h5>
                                                <Badge color={report.color} className="fs-6">
                                                    <i className="bx bx-chart me-1"></i>
                                                    Analytics
                                                </Badge>
                                            </div>
                                        </div>

                                        {/* Description */}
                                        <p className="text-muted mb-4 fs-6 lh-base">
                                            {report.description}
                                        </p>

                                        {/* Features List */}
                                        <div className="mb-4">
                                            <h6 className="fw-semibold text-dark mb-3">
                                                <i className="bx bx-check-circle me-2 text-success"></i>
                                                Key Features:
                                            </h6>
                                            <div className="row g-2">
                                                {report.features.map((feature, index) => (
                                                    <div className="col-6" key={index}>
                                                        <div className="d-flex align-items-center">
                                                            <i className="bx bx-check text-success me-2"></i>
                                                            <span className="fs-7 text-muted">{feature}</span>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                        {/* Action Button */}
                                        <div className="mt-auto">
                                            <Button
                                                color={report.color}
                                                className="w-100 btn-lg fw-semibold"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    onNavigateReport(report.link);
                                                }}
                                            >
                                                <i className="bx bx-right-arrow-alt me-2"></i>
                                                Access Report
                                            </Button>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        ))}
                    </Row>

                    {/* Quick Stats Section */}
                    <Row className="mt-5">
                        <Col lg={12}>
                            <Card className="border-0 shadow-sm">
                                <CardBody className="p-4">
                                    <h4 className="card-title mb-4">
                                        <i className="bx bx-stats me-2 text-primary"></i>
                                        Quick Overview
                                    </h4>
                                    <Row className="g-3">
                                        <Col md={3} sm={6}>
                                            <div className="text-center p-3 border rounded bg-light">
                                                <i className="bx bx-group fs-2 text-primary mb-2"></i>
                                                <h5 className="mb-1 fw-bold">6</h5>
                                                <p className="text-muted mb-0">Available Reports</p>
                                            </div>
                                        </Col>
                                        <Col md={3} sm={6}>
                                            <div className="text-center p-3 border rounded bg-light">
                                                <i className="bx bx-dollar-circle fs-2 text-success mb-2"></i>
                                                <h5 className="mb-1 fw-bold">Revenue</h5>
                                                <p className="text-muted mb-0">Financial Analytics</p>
                                            </div>
                                        </Col>
                                        <Col md={3} sm={6}>
                                            <div className="text-center p-3 border rounded bg-light">
                                                <i className="bx bx-ticket fs-2 text-warning mb-2"></i>
                                                <h5 className="mb-1 fw-bold">Sales</h5>
                                                <p className="text-muted mb-0">Ticket Performance</p>
                                            </div>
                                        </Col>
                                        <Col md={3} sm={6}>
                                            <div className="text-center p-3 border rounded bg-light">
                                                <i className="bx bx-search-alt fs-2 text-info mb-2"></i>
                                                <h5 className="mb-1 fw-bold">Search</h5>
                                                <p className="text-muted mb-0">Advanced Analytics</p>
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

          
        </React.Fragment>
    );
};



export default withTranslation()(Reports);

